import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const ShareIcon = forwardRef<SVGSVGElement, IconProps>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M11.293 1.293a1 1 0 0 1 1.414 0l4 4a1 1 0 0 1-1.414 1.414L13 4.414V15a1 1 0 1 1-2 0V4.414L8.707 6.707a1 1 0 0 1-1.414-1.414l4-4Z" />
    <path d="M4 11a1 1 0 0 1 1 1v8a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-8a1 1 0 1 1 2 0v8a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3v-8a1 1 0 0 1 1-1Z" />
  </Icon>
));
export default ShareIcon;
